import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && cfg.url?.startsWith("/admin/") && !cfg.url.startsWith("/admin/auth")) {
      cfg._retry = true;
      try {
        await api.post("/admin/auth/refresh");
        return api(cfg);
      } catch (e) {
        /* fall through */
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const SUPPORT_EMAIL = "support@whenthetimeisripe.com";

export function useContent() {
  return useQuery({ queryKey: ["content"], queryFn: async () => (await api.get("/content")).data, staleTime: 0, refetchOnWindowFocus: true, refetchOnMount: "always" });
}

export function usePayConfig() {
  return useQuery({ queryKey: ["paycfg"], queryFn: async () => (await api.get("/payments/config")).data, staleTime: 60_000 });
}

export const inIndia = (cfg) => {
  if (cfg?.country) return cfg.country === "IN";
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  return tz === "Asia/Kolkata" || tz === "Asia/Calcutta";
};

export const regionPrices = (prices, cfg) => {
  const want = inIndia(cfg) ? "razorpay" : "paypal";
  const hit = prices.filter((p) => p.provider === want);
  return hit.length ? hit : prices;
};
